$eve_checkbox_labelled $eve_button
	variant \ghost
	size? \m
	justify_content \flex-start
	sub /
		<= Checkbox $eve_checkbox
			checked? <=> checked? false
			disabled? <=> disabled? false
			indeterminate? <=> indeterminate? false
		<= Label $eve_text
			variant \text
			colors? null
			text_variant \bodyMd
			content <= label \

